import React from "react";
import { formatToken } from "../../utils/format";
import { TOKEN_SYMBOL } from "../../config/config";
import "./ClaimSection.css";

export default function ClaimSection({ claimable, onClaim, processing }) {
  const isZero = !claimable || claimable.isZero();

  return (
    <div className={`claim-badge ${isZero ? "claim-badge-empty" : "claim-badge-ready"}`}>
      <div className="claim-badge-glow" />
      <div className="claim-badge-icon">&#9889;</div>
      <div className="claim-badge-body">
        <div className="claim-badge-row">
          <span className="claim-badge-label">Available to Claim</span>
          {!isZero && <span className="claim-badge-live">LIVE</span>}
        </div>
        <div className="claim-badge-amount-row">
          <span className="claim-badge-value">{formatToken(claimable)}</span>
          <span className="claim-badge-unit">{TOKEN_SYMBOL}</span>
        </div>
      </div>
      <button
        className="claim-badge-btn"
        onClick={onClaim}
        disabled={processing || isZero}
      >
        {processing ? "..." : "Claim"}
      </button>
    </div>
  );
}
